import { render, staticRenderFns } from "./CancelBindingPhone.vue?vue&type=template&id=8d13211c&scoped=true&"
import script from "./CancelBindingPhone.vue?vue&type=script&lang=js&"
export * from "./CancelBindingPhone.vue?vue&type=script&lang=js&"
import style0 from "./CancelBindingPhone.vue?vue&type=style&index=0&id=8d13211c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d13211c",
  null
  
)

export default component.exports